<template>
  <v-app-bar
    class="appbar"
    floating
    min-width="100%"
    flat
    color="white"
  >
    <AppBadgeIcon
      v-if="showBadges"
      redirect="chat-index"
      :counter="unreadMessagesCount"
      icon="chat"
    />

    <AppBadgeIcon
      v-if="showBadges"
      redirect="notifications"
      :counter="unreadNotificationsCount"
      icon="notification"
    />

    <AppUser
      class="ml-2"
      :user="user"
    />

    <v-menu
      bottom
      left
      offset-y
    >
      <template #activator="{ on, attrs }">
        <v-btn
          icon
          small
          v-bind="attrs"
          class="ml-2"
          v-on="on"
        >
          <v-icon>mdi-menu-down</v-icon>
        </v-btn>
      </template>

      <v-list min-width="160px">
        <v-list-item
          dense
          :to="{ name: 'user-settings'}"
          exact
        >
          Ustawienia
        </v-list-item>

        <v-list-item
          dense
          @click="logout"
        >
          Wyloguj
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import AppUser from '@/components/UI/AppUser.vue';
import AppBadgeIcon from '@/components/UI/AppBadgeIcon.vue';

export default {
  components: {
    AppUser,
    AppBadgeIcon,
  },

  props: {
    showBadges: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('chat', [
      'unreadMessagesCount',
    ]),
    ...mapState('notifications', [
      'unreadNotificationsCount',
    ]),
    ...mapState('auth', [
      'user',
    ]),
  },

  methods: {
    ...mapActions('auth', [
      'logout',
    ]),
  },
};
</script>

<style lang="scss">
.appbar {
  padding: 0 24px;
  justify-content:flex-end;
  &__avatar {
    margin:0 16px 0 52px
  }
  &__name {
    font-size:14px;
    font-weight:500;
  }
  &__roles {
    font-size:10px;
  }
}
</style>
